import { Formik } from 'formik'
import { FC } from 'react'
import { Redirect } from 'react-router-dom'
import * as Yup from 'yup'
import { maxLength, requiredTrans } from '../forms/formTranslations'
import { GoalSelection } from './GoalSelection'
import FirstLoginFlowLayout from './layout'
import { FirstLoginFlowGoalType } from './types'
import { useGoalOption } from './useGoalOption'

export interface FirstLoginFlowFormikProps {
  goal: FirstLoginFlowGoalType
  goalCompleted: boolean
  displayOrganizationConnectDialog: boolean
  displayCreateNewOrganizationDialog: boolean
  displayOrganizationCreatedWindow: boolean
  search: string
  results: any
  resultsError: string
  selectedOrganizationId: string | null
  joinOrganizationIds: string[] | null
  jobTitle: string
  isRequestSent: boolean
}

const FirstLoginFlow: FC<{ initialValues?: Partial<FirstLoginFlowFormikProps> }> = ({ initialValues }) => {
  const { goalOptions } = useGoalOption()

  const initialFormValues = {
    goal: '' as FirstLoginFlowGoalType,
    goalCompleted: false,
    displayOrganizationConnectDialog: false,
    displayCreateNewOrganizationDialog: false,
    displayOrganizationCreatedWindow: false,
    search: '',
    results: null,
    resultsError: '',
    joinOrganizationIds: null,
    selectedOrganizationId: null,
    jobTitle: '',
    isRequestSent: false,
    ...initialValues
  }

  return (
    <Formik
      initialValues={initialFormValues}
      onSubmit={(values) => {
      }}
      validationSchema={
        Yup.object().shape({
          // @ts-expect-error
          goal: Yup.string().required(requiredTrans),
          // @ts-expect-error
          search: Yup.string().required(requiredTrans),
          // @ts-expect-error
          jobTitle: Yup.string().required(requiredTrans).max(80, maxLength({ max: 80 }))
        })
      }
    >
      {(formik) => {
        const { goalCompleted } = formik.values

        if (goalCompleted) {
          return (
            <Redirect
              to={{
                pathname: '/connect-organization',
                state: {
                  ...formik.values,
                  goalOptions: goalOptions.filter(option => {
                    return option.value === 'Apply for funding' || option.value === 'Fill grantee report' || option.value === 'Complete the organizational compass' || option.value === 'Create action plan'
                  })
                }
              }}
            />
          )
        }

        return (
          <FirstLoginFlowLayout>
            <GoalSelection goalOptions={goalOptions} />
            {/* {!goalCompleted && <GoalSelection goalOptions={goalOptions}/>}
            {goalCompleted && !displayOrganizationConnectDialog && !displayCreateNewOrganizationDialog && !displayOrganizationCreatedWindow
              && <ConnectToOrganization
                goalOptions={goalOptions.filter(option => {
                  return option.value === 'Apply for funding' || option.value === 'Fill grantee report' || option.value === 'Complete the organizational compass'
                })}
              />
            }
            {displayOrganizationConnectDialog && !results && !isRequestSent && !resultsError &&
              <OrganizationConnectSearch displayBackBtn={true}/>
            }
            {displayOrganizationConnectDialog && results && <OrganizationConnectResults/>}
            {resultsError && <>
              {resultsError === 'TOO_MANY_RECORDS_FOUND_ERROR' && <OrganizationConnectTooManyResults/>}
              {resultsError === 'NO_ORGANIZATION_FOUND_ERROR' && <OrganizationConnectNoResults/>}
            </>}
            {isRequestSent && <OrganizationConnectRequestSent/>}
            {displayCreateNewOrganizationDialog && <CreateNewOrganization/>}
            {displayOrganizationCreatedWindow && <OrganizationCreated/>} */}
          </FirstLoginFlowLayout>
        )
      }}
    </Formik>
  )
}

export default FirstLoginFlow
